import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { LinqFormsModule } from '@app/shared/forms/forms.module';
import { AccountService } from '@app/shared/services';
import { BankService } from '@app/shared/services/bank.service';
import { ApprovalLevelComponent } from './approval-setup/approval-level/approval-level.component';
import { ApprovalSetupComponent } from './approval-setup/approval-setup.component';
import { ApprovalUserComponent } from './approval-setup/approval-user/approval-user.component';
import { ApprovalSetupService } from './approval-setup/services/approval-setup-service';
import { BankingListComponent } from './banking-info/bank-list/bank-list.component';
import { ClearedCheckLayoutComponent } from './banking-info/cleared-check-layout/cleared-check-layout.component';
import { FieldsOverlappingValidatorDirective } from './banking-info/cleared-check-layout/directives/cleared-check-layout-fields-validator.directive';
import { ClearedCheckLayoutService } from './banking-info/services/cleared-check-layout.service';
import { NotificationsGridComponent } from './notifications/components/notifications-grid/notifications-grid.component';
import { NotificationsSetupComponent } from './notifications/notifications-setup.component';
import { NotificationService } from './notifications/services/notification.service';
import { CreditCardSetupComponent } from './payment-card-setup/credit-card-setup/credit-card-setup.component';
import { PaymentCardSetupComponent } from './payment-card-setup/payment-card-setup.component';
import { PurchaseCardImportSetupComponent } from './payment-card-setup/purchase-card-setup/import-setup/import-setup.component';
import { PurchaseCardSetupComponent } from './payment-card-setup/purchase-card-setup/purchase-card-setup.component';
import { PurchaseCardImportSetupService } from './payment-card-setup/services/purchase-card-import-setup.service';
import { PurchaseCardSetupService } from './payment-card-setup/services/purchase-card-setup.service';
import { VirtualCardSetupComponent } from './payment-card-setup/virtual-card-setup/virtual-card-setup.component';
import { PurchaseOrderSetupComponent } from './purchase-order-setup/purchase-order-setup.component';
import { PurchaseOrderSetupService } from './purchase-order-setup/services/purchase-order-setup.service';
import { SystemSettingsSystemSetupRoutingModule } from './system-setup-routing.module';
import { UnitSetupComponent } from './unit-setup/unit-setup.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		SystemSettingsSystemSetupRoutingModule,
		LinqFormsModule,
		ClearedCheckLayoutComponent,
		FieldsOverlappingValidatorDirective,
		ApprovalLevelComponent,
		ApprovalSetupComponent,
		ApprovalUserComponent,
		PurchaseCardSetupComponent,
		PurchaseOrderSetupComponent,
		NotificationsSetupComponent,
		NotificationsGridComponent,
		VirtualCardSetupComponent,
		PaymentCardSetupComponent,
		CreditCardSetupComponent,
		PurchaseCardImportSetupComponent,
		UnitSetupComponent,
		BankingListComponent,
	],
	providers: [
		ClearedCheckLayoutService,
		ApprovalSetupService,
		PurchaseOrderSetupService,
		PurchaseCardSetupService,
		PurchaseCardImportSetupService,
		NotificationService,
		BankService,
		AccountService,
	],
})
export class SystemSettingsSystemSetupModule {}
